export const transfromViewSimilarData = (data : Listing.IProduct) =>{
    return { ...data, actionUrl : data.action_url };
};
